import { ACTIVITIES_GLOBAL, ACTIVITIES_MINE } from '@/model/activities'

export default {
    title: 'Activities',
    items: {
        [ACTIVITIES_GLOBAL]: 'all',
        [ACTIVITIES_MINE]: 'my own'
    },
    alternative: 'There are no activities, yet.',
    empty: {
        title: 'Looking for content?',
        content: 'There are no activities yet.'
    }
}
